'use strict';

import React, { Component, Fragment } from 'react';
import moment from 'moment';
import uniqid from 'uniqid';
import MomentUtils from '@material-ui/pickers/adapter/moment';
import { StaticDatePicker } from '@material-ui/pickers';
import { LocalizationProvider } from '@material-ui/pickers';
import Popover from '@material-ui/core/Popover';
import Button from '@material-ui/core/Button';
import DateIcon from '@material-ui/icons/Today';
import bemit from 'Functions/bemit';
let app = window.app;
export default class DatePicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      id: uniqid(),
      label: 'Aucune',
      popup: false,
      anchor_element: null
    };
    const {
      default_value,
      format
    } = this.props;
    if (props.value) {
      this.state.value = moment(props.value).format(format || 'YYYY-MM-DD');
      this.state.label = this.getDateLabel(moment(props.value, format), format);
    } else if (this.props['allow-no-value'] !== true) {
      this.state.value = default_value ? moment(default_value).format(format || 'YYYY-MM-DD') : moment().format(format || 'YYYY-MM-DD');
      this.state.label = default_value ? this.getDateLabel(moment(default_value, format), format) : this.getDateLabel(moment(), format);
    }
  }
  button_ref = this.props['btn-ref'] || React.createRef();
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (props.value) {
      component.setComponentData(props.value);
    } else if (props.default_value) {
      component.setComponentData(props.default_value);
    } else if (!props['allow-no-value']) {
      component.changeDate(moment());
    }
  }
  componentDidUpdate(prev_props, prev_state) {
    const component = this,
      props = this.props,
      state = this.state;
    if (prev_props.value !== props.value) {
      component.setComponentData(props.value);
    }
  }
  setComponentData = value => {
    const component = this,
      props = this.props,
      state = this.state;
    const format = props.format || 'YYYY-MM-DD';
    const date = props['allow-no-value'] && !value ? '' : moment(value || props.value || moment(), format);
    const label = component.getDateLabel(date, props['label-format']);
    component.setState({
      value: date,
      label: label
    });
    component.closePopup();
  };
  changeDate = (...properties) => {
    const component = this,
      props = this.props,
      state = this.state;
    const [date, string] = properties;
    const label = component.getDateLabel(date, props['label-format']);
    component.setState({
      label: label
    });
    component.closePopup();
    props.onChange({
      value: date.format(props.format || 'YYYY-MM-DD'),
      name: props.name,
      error_name: component.getStatusName()
    });
  };
  removeDocumentScroll = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const scroll_width = window.innerWidth - document.body.clientWidth;
    let scroll_area = document.querySelector('.front-page, .back-page');
    scroll_area.style.paddingRight = scroll_width + 'px';
    document.querySelector('html').classList.add('u-lock-scroll-' + state.id);
  };
  restoreDocumentScroll = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const html = document.querySelector('html');
    if (html.className.split('u-lock-scroll-').length > 2 === false) {
      let scroll_area = document.querySelector('.front-page, .back-page');
      scroll_area.style.paddingRight = '';
    }
    html.classList.remove('u-lock-scroll-' + state.id);
  };
  openPopup = e => {
    const component = this,
      props = this.props,
      state = this.state;
    e.persist();
    component.removeDocumentScroll();
    component.setState({
      popup: true,
      anchor_element: e.target
    });
  };
  closePopup = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.restoreDocumentScroll();
    component.setState({
      popup: false,
      anchor_element: null
    });
  };
  reset = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.closePopup();
    props.onChange({
      e: undefined,
      value: '',
      name: props.name,
      error_name: component.getStatusName()
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    moment.locale(props.lang?.toLowerCase() || 'fr');
    let date = moment(state.value, props.format || 'YYYY-MM-DD');
    let status = props.status[component.getStatusName()] || {};
    const info = status.info ? /*#__PURE__*/React.createElement("div", {
      className: bemit('c-field-msg', ['green', 'date-picker'])
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-field-msg__content"
    }, status.info)) : undefined;
    const error = status.error ? /*#__PURE__*/React.createElement("div", {
      className: bemit('c-field-msg', ['red', 'date-picker'])
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-field-msg__content"
    }, status.error)) : undefined;
    const warning = status.warning ? /*#__PURE__*/React.createElement("div", {
      className: bemit('c-field-msg', ['orange', 'date-picker'])
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-field-msg__content"
    }, status.warning)) : undefined;
    let disableFunction = undefined;
    if (props['start-of-month']) {
      disableFunction = notStartOfMonth;
    } else if (props['no-past'] && props['no-today']) {
      disableFunction = futureOnly;
    } else if (props['no-past']) {
      disableFunction = noPast;
    }
    let display_value = /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(DateIcon, {
      className: "c-form-element__date-icon"
    }), props['hide-label'] ? undefined : state.label);
    let modifiers = ['date'].concat(props.bemit || []);
    if (props['short-format']) {
      modifiers.push('short-date');
      if (!state.value) {
        display_value = /*#__PURE__*/React.createElement(DateIcon, {
          className: "c-form-element__date-icon"
        });
      } else {
        display_value = /*#__PURE__*/React.createElement(Fragment, null, date.format(props['label-format'] || 'DD MMM YY'));
      }
    }
    let output = /*#__PURE__*/React.createElement("div", {
      className: bemit('c-form-element', modifiers) + ' ' + (props.className || '')
    }, props.label ? /*#__PURE__*/React.createElement("div", {
      className: "c-form-element__label",
      onClick: props['read-only'] ? undefined : component.openPopup
    }, props.label) : undefined, error, warning, info, /*#__PURE__*/React.createElement(Button, {
      type: "button",
      className: props['btn-class'] || 'c-form-element__date',
      ref: component.button_ref,
      onClick: component.openPopup,
      disabled: props['read-only']
    }, display_value), /*#__PURE__*/React.createElement(Popover, {
      id: state.id,
      open: state.popup,
      anchorEl: state.anchor_element,
      onClose: component.closePopup,
      className: props.className,
      anchorOrigin: {
        vertical: 'center',
        horizontal: 'center'
      },
      transformOrigin: {
        vertical: 'center',
        horizontal: 'center'
      },
      disableScrollLock: true
    }, /*#__PURE__*/React.createElement(LocalizationProvider, {
      dateAdapter: MomentUtils,
      dateLibInstance: moment
    }, /*#__PURE__*/React.createElement(StaticDatePicker, {
      orientation: "landscape",
      autoOk: true,
      openTo: "date",
      value: date,
      onChange: component.changeDate,
      allowKeyboardControl: true,
      showToolbar: false,
      shouldDisableDate: disableFunction
    }), props['allow-no-value'] ? /*#__PURE__*/React.createElement(Button, {
      onClick: component.reset,
      className: "reset-mui-date"
    }, "Supprimer") : undefined)));
    return output;
  }
  getDateLabel = (date, format = 'DD/MM/YYYY') => {
    const component = this,
      props = this.props,
      state = this.state;
    let label;
    if (!date && props['allow-no-value']) {
      return 'Aucune';
    }
    if (moment().isSame(date, 'day')) {
      label = 'Aujourd\'hui';
    } else if (moment().add(1, 'day').isSame(date, 'day')) {
      label = 'Demain';
    } else if (moment().subtract(1, 'day').isSame(date, 'day')) {
      label = 'Hier';
    } else {
      label = moment(date).format(format);
    }
    return label;
  };
  getStatusName = () => {
    const component = this,
      props = this.props,
      state = this.state;
    return !props['error-prefix'] ? props.name : props.name?.includes('[') === true ? props['error-prefix'] + '[' + props.name.replace('[', '][') : props['error-prefix'] + '[' + props.name + ']';
  };
}
function notStartOfMonth(date) {
  return moment(date).get('date') !== 1;
}
function noPast(date) {
  return moment(date).isBefore(moment(), 'day');
}
function futureOnly(date) {
  return moment(date).isBefore(moment().add(1, 'day'), 'day');
}
